import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import { Icon } from "./icon";
import { AllocationsList } from "./allocationsList";
import { Status } from "./status";
import styles from "./styles.scss";

function Element(_: Props) {
  return (
    <div className={styles.element}>
      <Icon className={styles.icon} />
      <div className={styles.main}>
        <div className={styles.header}>
          <Skeleton className={styles.name} />
          <div className={styles.allocations}>
            <AllocationsList />
          </div>
        </div>
        <div className={styles.footer}>
          <div>
            <div className={styles.status}>
              <Status />
            </div>
          </div>
          <div>
            <Skeleton className={styles.zone} />
          </div>
          <div>
            <div className={styles.project}>
              <Skeleton className={styles.projectIcon} />
              <Skeleton className={styles.projectName} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Element };
